module.exports = "<div [hidden]=\"!isSpinnerVisible\" id=\"spinner-wrap\">\r\n    <div class=\"spinner\">\r\n        <div class=\"double-bounce1\"></div>\r\n        <div class=\"double-bounce2\"></div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/spinner/spinner.component.html
// module id = ./src/app/components/spinner/spinner.component.html
// module chunks = main